/*
 * @Author: wsx
 * @Date: 2022-01-23 15:48:50
 * @LastEditTime: 2022-01-23 15:50:42
 * @LastEditors: your name
 * @Description: 首页接口
 */
import request from "@/utils/request";

// 实有人口_性别
export const getPrisonSex = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/prison/sex",
    params: data
  });
};

// 实有安防
export const getSecurity = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/security/count",
    params: data
  });
};

// 实有力量
export const getStrength = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/strength/count",
    params: data
  });
};

// 实有装备
export const getEquipment = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/equipment/count",
    params: data
  });
};
// 实有房屋
export const getHouseCount = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/house/count",
    params: data
  });
};
// 实有单位
export const getUnitCount = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/unit/count",
    params: data
  });
};

// 事件总量
export const getEventCount = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/event/count",
    params: data
  });
};

// 重点人员
export const getImpotanceCount = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/sytp/impotanceCount",
    params: data
  });
};

// 事件上报列表
export const getEventList = data => {
  return request({
    url: "/api/hz-smart-community/event/list",
    method: "post",
    data: data
  });
};
//设备告警总数
export const getDeviceWarning = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/sytp/deviceWarning",
    params: data
  });
};

//地图点位

// 实有单位
export const getUnitRegion = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/unit/region",
    params: data
  });
};


// 房屋名查房屋
export const getHouseRegion = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/house/region",
    params: data
  });
};

// 重点人员
export const getPersonNumByRegion = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/sytp/personNumByRegion",
    params: data
  });
};

// 安防设施
export const getSecurityRegion = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/security/region",
    params: data
  });
};